import { createApp } from "vue";
import { createI18n } from "vue-i18n";

// Root file
import App from "./root.vue";

// Vuex store (nếu chưa có thì dùng placeholder)
import store from "./../../store/root.vuex";

// Router
import router from "./routes";

// Icons, UI
import "bootstrap-icons/font/bootstrap-icons.css";
import Notifications from "@kyvg/vue3-notification";

// Global Components
import Statistics from './../../components/Statistics.vue';
import Loader from "./../../components/Loader.vue";

// --- i18n Setup ---
const userLang = document.documentElement.lang || "vi";

// Import language files
import vi from "./../../../lang/vi.json";
import en from "./../../../lang/en.json";

const messages = { vi, en };

const i18n = createI18n({
    legacy: false,
    locale: userLang,
    fallbackLocale: "vi",
    messages,
    missingWarn: false,
    fallbackWarn: false,
});

// --- Initialize App ---
async function initApp() {
    try {
        await Promise.all([
            store.dispatch("user/fetchUser"),
            store.dispatch("options/fetchSettings"),
        ]);
    } catch (error) {
        console.error("Lỗi khi khởi tạo ứng dụng:", error);
    }

    const app = createApp(App);

    // Global registered components
    app.component("Statistics", Statistics);
    app.component("Loader", Loader);

    // Plugins
    app.use(Notifications);
    app.use(i18n);
    app.use(store);
    app.use(router);

    // Mount
    app.mount("#app");
}

initApp();
